import { render, staticRenderFns } from "./AppColorPicker.vue?vue&type=template&id=299af406"
import script from "./AppColorPicker.vue?vue&type=script&lang=ts"
export * from "./AppColorPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports